export const buildPowerUserResultOption = option => {
  const wrapper = document.createElement("div");
  wrapper.className = "power-user-navigation-select-option--wrapper";
  const moduleImage = document.createElement("div");
  moduleImage.className = `power-uers-nav-module nav-module-${option.module}`;
  const menuItem = document.createElement("div");
  menuItem.classList.add("power-user-navigation-select-option--item");
  const menuItemTitle = document.createElement("div");
  menuItemTitle.textContent = option.text;
  const menuItemSubTitle = document.createElement("div");
  menuItemSubTitle.classList.add("module-name");
  menuItemSubTitle.textContent = option.levelOneTitle;
  menuItem.appendChild(menuItemTitle);
  menuItem.appendChild(menuItemSubTitle);
  wrapper.appendChild(moduleImage);
  wrapper.appendChild(menuItem);
  return wrapper;
};

export const buildPowerUserSelectionOption = option => {
  const menuItem = document.createElement("span");
  menuItem.textContent = option.text;
  return menuItem;
};
